import { useEffect, useState } from 'react';
import { onSync, requestSync, type SyncResult } from '../lib/sync.ts';

/** Tells the user whether their wallet is backed up, without ever getting in the way. */
export function SyncBadge() {
  const [last, setLast] = useState<SyncResult | null>(null);
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));

  useEffect(() => {
    const off = onSync(setLast);
    const update = () => setOnline(navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      off();
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  const offline = !online || last?.status === 'offline';
  const label = offline ? 'Offline — le modifiche partiranno da sole' : 'Sincronizzato';

  return (
    <button
      className="icon-button"
      onClick={() => requestSync(0)}
      title={label}
      aria-label={label}
      style={{ width: 36, minHeight: 36 }}
    >
      <span className={`sync-dot ${offline ? 'offline' : 'ok'}`} />
    </button>
  );
}
